import { stringValue } from "@/utils/coerce";

export function formatMs(value: number | null | undefined) {
  if (value === null || value === undefined) return "-";
  if (value < 1000) return `${value} ms`;
  if (value < 60000) return `${(value / 1000).toFixed(value < 10000 ? 1 : 0)} s`;
  return `${(value / 60000).toFixed(1)} min`;
}

export function compactTime(value: unknown) {
  const raw = stringValue(value, "");
  if (!raw) return "-";
  const date = new Date(raw);
  if (Number.isNaN(date.getTime())) return raw;
  return date.toLocaleString();
}

export function formatBytes(size: number) {
  if (size < 1024) return `${size} B`;
  if (size < 1024 * 1024) return `${(size / 1024).toFixed(1)} KB`;
  return `${(size / 1024 / 1024).toFixed(1)} MB`;
}

/** A provider-billed USD amount. One LLM call is often well under a cent. */
export function formatUsd(value: number) {
  return `$${value < 0.01 ? value.toFixed(5) : value.toFixed(4)}`;
}
